var module = angular.module('components');
module.component('caFormGroupRow', {
    templateUrl: 'components/genericcomponents/formgrouprow.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        label: '<'
    },
    transclude: true
});
